import { memo, useMemo } from "react"
import { useTranslation } from "react-i18next"
import Slot from "../../../../components/Slot"
import { ICON } from "../../../../components/Icon/data"

type StatusColumn = {
  status?: string[]
}

const StatusColumn = memo(({ status = [] }: StatusColumn) => {
  const { t } = useTranslation()

  const STATUS_MAP = {
    overdue: {
      label: t('Overdue'),
      color: 'red',
      icon: ICON.WARNING
    },
    due_soon: {
      label: t('Due soon'),
      color: 'yellow',
      icon: ICON.WARNING_ALT
    },
    upcoming: {
      label: t('Upcoming'),
      color: 'green',
      icon: ICON.WARNING_ALT 
    }
  }

  const statusFormat = useMemo(() => {
    if (Array.isArray(status)) return status
    if (!status) return []
    return [status]
  }, [status])

  if (!status?.length) return null

  return (
    <div className="StatusColumn">
      {statusFormat?.map((s) => {
        return (
          <Slot {...STATUS_MAP[s]} />
        )
      })}
    </div>
  )
})

export default StatusColumn
